import { useActiveConversationData } from 'hooks/useActiveConversationData'
import { Attachment, MessageReference } from 'types/Api'

export type InlineReferenceType = 'document-reference' | 'karnov-document' | 'attachment' | 'company-upload'

export type InlineReferenceByType
  = | { type: 'document-reference' | 'karnov-document' | 'company-upload', attachment?: undefined }
    | { type: 'attachment', attachment: Attachment }

export const useInlineReferenceType = (
  messageId: string,
  reference: MessageReference,
): InlineReferenceByType => {
  const { activeConversationData } = useActiveConversationData()

  const aiMessage = activeConversationData?.messages.find(m => m.id === messageId)
  const parentMessage = activeConversationData?.messages.find(m => m.id === aiMessage?.parentId)

  if (reference.sourceType === 'karnov_document') {
    const isUserTagged = parentMessage?.documentReferences.some(
      docRef => docRef.citation !== null && reference.metadata.citations.includes(docRef.citation),
    ) ?? false
    return { type: isUserTagged ? 'document-reference' : 'karnov-document' }
  }

  const attachment = parentMessage?.attachments.find(a => a.uuid === reference.topId)
  return attachment ? { type: 'attachment', attachment } : { type: 'company-upload' }
}
